import React from 'react';

const About = () => {
  return (
    <div className="container mx-auto pt-10 px-10 lg:w-6/12 lg:pt-28">
      <h1 className="tracking-widest text-2xl text-gray-700 font-black pt-5">
        About Me
      </h1>
      <p className="text-1xl text-gray-500 pt-4">
        As a software development mentor at a coding bootcamp and computer
        science student at Grand Canyon University, I'm passionate about
        teaching web development and empowering students to succeed. With strong
        communication and problem-solving skills, I strive to make complex
        concepts accessible and engaging to learners of all levels. My goal is
        to help students become confident, skilled developers who are equipped
        to excel in the tech industry.
      </p>
    </div>
  );
};

export default About;
